<div class="content-info">
    <div class="content-title d-flex justify-content-between align-items-center">
        <h3 class="title mb-0">Locations List</h3>
        <div class="d-flex align-items-center gap-2">
            <div class="form-group mb-0" style="min-width: 250px;">
                <div class="input-group">
                    <span class="input-group-text bg-white border-end-0">
                        <i class="bi bi-search text-muted"></i>
                    </span>
                    <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()"
                        placeholder="Search by name or type..." class="form-control border-start-0" />
                </div>
            </div>

            <button class="btn btnprimary text-white text-nowrap" routerLink="/locations/create">
                <i class="bi bi-plus-lg me-1"></i> Add Location
            </button>
        </div>
    </div>

    <div class="common-table mt-4">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Linked store</th>
                        <th>Status</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @if (locationsLoading) {
                    <tr>
                        <td colspan="5" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                    } @else {
                    @for (location of locations; track location.id) {
                    <tr>
                        <td>
                            <div class="loc-name" [style.padding-left.px]="(location.depth || 0) * 22">
                                @if (location.depth) {<span class="loc-branch">↳</span>}
                                <div>
                                    <div class="fw-semibold text-dark">{{ location.name }}</div>
                                    @if (location.parentName) {
                                    <div class="loc-parent" [class.warn]="location.misParented">
                                        Under {{ location.parentName }}
                                        @if (location.misParented) { — open edit and save to move it back to the top level }
                                    </div>
                                    }
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="badge bg-light text-dark border">{{ location.type }}</span>
                        </td>
                        <td>
                            @if (linkedStore(location); as st) {
                            <div class="loc-store">
                                <span class="loc-store-code">{{ st.storeCode }}</span>
                                <span class="loc-store-name">{{ st.name }}</span>
                                @if (!st.isActive) {
                                <span class="badge bg-light text-muted border">Inactive</span>
                                }
                            </div>
                            } @else {
                            <button type="button" class="btn btn-sm loc-tag-btn" [disabled]="!location.isActive"
                                [title]="location.isActive ? 'Create a store record for this location so it can be picked in the top bar' : 'Activate the location first'"
                                (click)="openTagStore(location)">
                                <i class="bi bi-plus-lg"></i> Tag store
                            </button>
                            <div class="loc-untagged">Not selectable in the store switcher</div>
                            }
                        </td>
                        <td>
                            <div class="form-check form-switch m-0 d-inline-flex align-items-center">
                                <input class="form-check-input" type="checkbox" [checked]="location.isActive"
                                    (change)="toggleStatus(location)" />
                                <span class="ms-2 small" [class.text-success]="location.isActive"
                                    [class.text-muted]="!location.isActive">
                                    {{ location.isActive ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-sm btn-outline-primary"
                                    [routerLink]="['/locations/edit', location.id]">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger"
                                    (click)="openDeleteConfirmationModal(confirmDeleteModal, location)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="5" class="text-center py-5 text-muted">
                            No locations found.
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="table-pagination">
            <div class="pagination-count">
                <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
                    <option [value]="10">10</option>
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                    <option [value]="100">100</option>
                </select>
                <span>entries per page</span>
            </div>
            <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
                    <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>

                <!-- First Page -->
                <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
                    <a class="page-link">1</a>
                </li>

                <!-- Left Ellipsis -->
                @if (currentPage > 4) {
                <li class="page-item disabled">
                    <a class="page-link">...</a>
                </li>
                }

                <!-- Visible Pages -->
                @for (page of getVisiblePages(); track page) {
                <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
                    <a class="page-link">{{ page }}</a>
                </li>
                }

                <!-- Right Ellipsis -->
                @if (currentPage < pageCount - 3) { <li class="page-item disabled">
                    <a class="page-link">...</a>
                    </li>
                    }

                    <!-- Last Page -->
                    @if (pageCount > 1) {
                    <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
                        <a class="page-link">{{ pageCount }}</a>
                    </li>
                    }

                    <li class="page-item" [class.disabled]="currentPage === pageCount"
                        (click)="goToPage(currentPage + 1)">
                        <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
            </ul>
        </div>
    </div>
</div>

<!-- Stores list -->
<div class="content-info mt-4">
    <div class="content-title d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
            <h3 class="title mb-0">Stores List</h3>
            <div class="st-sub">Store and warehouse records — what the store switcher, POS and documents use.</div>
        </div>
        <div class="d-flex align-items-center gap-2">
            <label class="zf-search">
                <i class="bi bi-search"></i>
                <input type="text" [(ngModel)]="storeSearch" placeholder="Search by name, code, city…" />
            </label>
            <button class="btn btnprimary text-white text-nowrap" (click)="openAddStore()"
                [disabled]="!untaggedLocations.length"
                [title]="untaggedLocations.length ? 'Create a store for an active Store / Warehouse location' : 'Every active Store / Warehouse location already has a store — add a location first'">
                <i class="bi bi-plus-lg me-1"></i> Add Store
            </button>
        </div>
    </div>

    <div class="common-table mt-4">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Store</th>
                        <th>Location</th>
                        <th>GSTIN / FSSAI</th>
                        <th>Address &amp; contact</th>
                        <th>Status</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @if (storesLoading) {
                    <tr>
                        <td colspan="6" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                    } @else {
                    @for (st of filteredStores; track st.id) {
                    <tr [class.st-off]="!st.isActive">
                        <td>
                            <div class="loc-store">
                                <span class="loc-store-code">{{ st.storeCode }}</span>
                                <div>
                                    <div class="fw-semibold text-dark">{{ st.name }}</div>
                                    @if (st.shortCode) {<div class="st-meta">Short code <span class="zf-mono">{{ st.shortCode }}</span></div>}
                                </div>
                            </div>
                        </td>
                        <td>
                            @if (st.location) {
                            <div class="text-dark">{{ st.location.name }}</div>
                            <span class="badge bg-light text-dark border">{{ st.location.type }}</span>
                            @if (st.location.isActive === false) {<span class="st-warn ms-1">location inactive</span>}
                            } @else { <span class="text-muted">–</span> }
                        </td>
                        <td>
                            <div class="zf-mono st-id">{{ st.gstin || '–' }}</div>
                            @if (st.fssaiNumber) {<div class="st-meta">FSSAI <span class="zf-mono">{{ st.fssaiNumber }}</span></div>}
                        </td>
                        <td>
                            <div class="st-addr" [title]="st.address">{{ st.address }}</div>
                            <div class="st-meta">
                                {{ placeLine(st) }}
                                @if (st.phone) {<span> · {{ st.phone }}</span>}
                            </div>
                        </td>
                        <td>
                            <div class="form-check form-switch m-0 d-inline-flex align-items-center">
                                <input class="form-check-input" type="checkbox" [checked]="st.isActive"
                                    [disabled]="storeStatusBusy.has(st.storeCode)"
                                    (click)="$event.preventDefault(); toggleStoreStatus(st)" />
                                <span class="ms-2 small" [class.text-success]="st.isActive"
                                    [class.text-muted]="!st.isActive">
                                    {{ st.isActive ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-sm btn-outline-primary" title="Edit store details"
                                    (click)="openEditStore(st)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="6" class="text-center py-5 text-muted">
                            {{ storeSearch ? 'No stores match the search.' : 'No stores yet — tag one to a location above or use Add Store.' }}
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Tag store dialog -->
@if (storeDialogMode) {
<div class="zf-overlay" (click)="closeTagStore()">
    <div class="zf-dialog w-600" (click)="$event.stopPropagation()">
        <div class="zf-dialog-head">
            <h3>{{ storeDialogMode === 'edit' ? 'Edit store' : pickLocation ? 'Add store' : 'Tag a store' }}</h3>
            @if (tagLocation) {
            <span class="zf-sum-chip primary"><span class="k">{{ tagLocation.type }}</span>{{ tagLocation.name }}</span>
            }
            <button type="button" class="zf-x" aria-label="Close" (click)="closeTagStore()">✕</button>
        </div>

        <form class="zf-dialog-body" (ngSubmit)="saveTagStore()">
            @if (storeDialogMode === 'edit') {
            <div class="zf-alert info">
                <i class="bi bi-info-circle-fill"></i>
                <span>Store code, short code and location can't change once a store exists — they are printed on
                    bills and documents already issued.</span>
            </div>
            } @else {
            <div class="zf-alert info">
                <i class="bi bi-info-circle-fill"></i>
                <span>Creates the {{ isWarehouseTag ? 'warehouse' : 'store' }} record for {{ tagLocation ? 'this' : 'a' }} location. Admins get
                    access straight away, so it shows up in the store switcher at the top.</span>
            </div>
            }
            @if (storeError) {
            <div class="zf-alert danger">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <span>{{ storeError }}</span>
            </div>
            }

            <div class="zf-dialog-grid">
                @if (pickLocation) {
                <label class="zf-field" style="grid-column: 1 / -1">
                    <span class="zf-flabel">Location *</span>
                    <ng-select [items]="untaggedLocations" bindLabel="name" bindValue="id" name="locationId"
                        [(ngModel)]="storeForm.locationId" (ngModelChange)="onPickLocation($event)"
                        placeholder="Store / warehouse location without a store" appendTo="body" [clearable]="false">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="ss-row">
                                <span class="ss-row__primary">{{ item.name }}</span>
                                <span class="ss-row__secondary">{{ item.type }}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </label>
                }
                <label class="zf-field" style="grid-column: 1 / -1">
                    <span class="zf-flabel">Name *</span>
                    <input class="form-control" name="name" [(ngModel)]="storeForm.name" required />
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">Store code *</span>
                    <input class="form-control text-uppercase" name="storeCode" [(ngModel)]="storeForm.storeCode"
                        [readonly]="storeDialogMode === 'edit'" required />
                    <small class="zf-field-hint">Unique; used in PO / GRN numbers</small>
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">Short code {{ isWarehouseTag ? '*' : '' }}</span>
                    <input class="form-control text-uppercase" name="shortCode" maxlength="3"
                        [(ngModel)]="storeForm.shortCode" [readonly]="storeDialogMode === 'edit'" />
                    <small class="zf-field-hint">1–3 chars; {{ isWarehouseTag ? 'transfer box prefix' : 'bill number prefix' }}</small>
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">GSTIN {{ storeDialogMode === 'edit' ? '' : '*' }}</span>
                    <input class="form-control text-uppercase" name="gstin" maxlength="15"
                        [(ngModel)]="storeForm.gstin" required />
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">FSSAI number</span>
                    <input class="form-control" name="fssaiNumber" maxlength="14" [(ngModel)]="storeForm.fssaiNumber" />
                </label>
                <label class="zf-field" style="grid-column: 1 / -1">
                    <span class="zf-flabel">Address *</span>
                    <input class="form-control" name="address" [(ngModel)]="storeForm.address" required />
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">City</span>
                    <input class="form-control" name="city" [(ngModel)]="storeForm.city" />
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">State</span>
                    <ng-select [items]="indianStates" name="state" [(ngModel)]="storeForm.state"
                        placeholder="Select state" appendTo="body"></ng-select>
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">Pincode</span>
                    <input class="form-control" name="pincode" maxlength="6" [(ngModel)]="storeForm.pincode" />
                </label>
                <label class="zf-field">
                    <span class="zf-flabel">Phone</span>
                    <input class="form-control" name="phone" [(ngModel)]="storeForm.phone" />
                </label>
                <label class="zf-field" style="grid-column: 1 / -1">
                    <span class="zf-flabel">Email</span>
                    <input class="form-control" type="email" name="email" [(ngModel)]="storeForm.email" />
                </label>
            </div>
            <button type="submit" hidden></button>
        </form>

        <div class="zf-dialog-foot">
            <span class="note">Other users get access from Users → edit user.</span>
            <button type="button" class="btn border" (click)="closeTagStore()" [disabled]="storeSaving">Cancel</button>
            <button type="button" class="btn btnprimary text-white" (click)="saveTagStore()" [disabled]="storeSaving">
                @if (storeSaving) {<span class="spinner-border spinner-border-sm me-1"></span>}
                {{ storeDialogMode === 'edit' ? 'Save changes' : pickLocation ? 'Create store' : 'Create &amp; tag' }}
            </button>
        </div>
    </div>
</div>
}

<!-- Delete Confirmation Modal -->
<ng-template #confirmDeleteModal let-modal>
    <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold" id="confirmDeleteModalLabel">Confirm Deactivation</h5>
        <button type="button" class="btn-close shadow-none" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body py-4">
        <div class="text-center mb-4">
            <div class="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                style="width: 64px; height: 64px; font-size: 2rem;">
                <i class="bi bi-exclamation-triangle"></i>
            </div>
            <p class="text-dark mb-1">Are you sure you want to deactivate</p>
            <h5 class="fw-bold">{{ locationToDelete?.name }}?</h5>
            <p class="text-muted small mx-auto" style="max-width: 300px;">
                This action will mark the location as inactive. You can reactivate it later if needed.
            </p>
        </div>
    </div>
    <div class="modal-footer border-0 justify-content-center pb-4 pt-0">
        <button type="button" class="btn border px-4" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-danger px-4" (click)="confirmDelete()">Deactivate</button>
    </div>
</ng-template>